export default class Note {
    constructor(
        data={
            id:-1,
            body:'',
            dateCreated:'',
            lastUpdated:''
        }
    ) {
        this.id = data.id;
        this.body = data.body;
        this.dateCreated = data.dateCreated;
        this.lastUpdated = data.lastUpdated;
    }

    getId() {
        return this.id;
    }

    getBody() {
        return this.body;
    }

    getDateCreated() {
        return this.dateCreated;
    }

    getLastUpdated() {
        return this.lastUpdated;
    }

    hasTitle() {
        return this.title.length > 0;
    }

    toFormObject() {
        const obj = {
            id: this.id,
            body: this.body
        };

        return obj;
    }
}